export default {
    getUser(state){
        return state.user;
    },
    getsideBarMenusApi(state){
        return state.sideBarMenusApi;
    },
    getsideBarMenus(state){
        return state.currentSideMenu;
    },
}